const styles = {
  dark: {
    '--element-bgColor': (theme) => theme.palette.neutral[100],
    '--text-color': (theme) => theme.palette.neutral[700],
  },
  light: {
    '--element-bgColor': (theme) => theme.palette.neutral[200],
    '--text-color': (theme) => theme.palette.neutral[500],
  },
  root: {
    width: (theme) => ({
      xs: `calc(100% - ${theme.spacing(2)})`,
      sm: '100%',
    }),
    mx: 'auto',
    p: (theme) => ({
      xs: theme.spacing(2),
      md: theme.spacing(3),
      lg: theme.spacing(8, 4, 9),
      xl: theme.spacing(8, 8.75, 9),
    }),
    borderRadius: 2.5,
    color: 'var(--text-bgColor)',
    boxShadow: 4,
    backgroundColor: 'var(--element-bgColor)',
    position: {
      md: 'relative',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 2,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 1,
    width: (theme) => `min(${theme.spacing(23)}, 100%)`,
    opacity: 0.6,
  },
  text: {
    color: 'neutral.500',
  },
  wrapImage: {
    position: {
      lg: 'absolute',
    },
    top: (theme) => ({
      lg: theme.spacing(2.5),
    }),
    right: {
      lg: 0,
      xl: '8%',
    },
  },
}

export default styles
